<template>
    <div>
        <b-card class="bg-default-card no-padding" v-if="action && milestone && trajectory && project">
            <b-tabs card>
                <b-tab :title="uLang('app.entity_details', { entity: lang('app.action') })" active>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="inner">
                                <div class="mb-3">
                                    <router-link class="btn btn-brand" :to="{ name: 'admin.trajectory_projects.trajectories.milestones.actions.edit', params: { projectId: this.projectId, trajectoryId: this.trajectoryId, milestoneId: this.milestoneId, id: this.id } }">{{ uLang('app.edit_type', { type: lang('app.action') }) }}</router-link>
                                    <a class="btn btn-brand" href="#" @click.prevent="duplicate">{{ uLang('app.duplicate_type', { type: lang('app.action') }) }}</a>
                                </div>

                                <table class="table">
                                    <tr>
                                        <td width="200">{{ uLang('app.project_name') }}:</td>
                                        <td>
                                            <router-link :to="{ name: 'admin.trajectory_projects.view', params: { id: project.id }}">
                                                {{ project.name }}
                                            </router-link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.trajectory_name') }}:</td>
                                        <td>
                                            <router-link :to="{ name: 'admin.trajectory_projects.trajectories.view', params: { projectId: project.id, id: trajectory.id }}">
                                                {{ trajectory.name }}
                                            </router-link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.milestone_name') }}:</td>
                                        <td>
                                            <router-link :to="{ name: 'admin.trajectory_projects.trajectories.milestones.view', params: { projectId: project.id, trajectoryId: trajectory.id, id: milestone.id }}">
                                                {{ milestone.name }}
                                            </router-link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.name') }}:</td>
                                        <td>{{ action.name }}</td>
                                    </tr>
                                    <tr v-if="action.depends_on_type">
                                        <td width="200">{{ uLang('app.depends_on') }}:</td>
                                        <td>{{ Number.isInteger(action.depends_on_action_id) ? action.depends_on_action.name : uLang('app.' + action.depends_on) }}</td>
                                    </tr>
                                    <tr v-if="action.lead_time_in_days">
                                        <td width="200">{{ uLang('app.lead_time_in_days') }}:</td>
                                        <td>{{ action.lead_time_in_days }}</td>
                                    </tr>
                                    <tr v-if="action.lead_time_of_type">
                                        <td width="200">{{ uLang('app.lead_time_of') }}:</td>
                                        <td>{{ Number.isInteger(action.lead_time_of_action_id) ? action.lead_time_of_action.name : uLang('app.' + action.lead_time_of) }}</td>
                                    </tr>
                                    <tr v-if="action.assigned_to_role">
                                        <td width="200">{{ uLang('app.assigned_to_role') }}:</td>
                                        <td><b-badge pill variant="primary">{{ action.assigned_to_role.name }}</b-badge></td>
                                    </tr>
                                    <tr v-if="action.action_document_category">
                                        <td width="200">{{ uLang('app.action_document_category') }}:</td>
                                        <td><b-badge pill variant="primary">{{ action.action_document_category.name }}</b-badge></td>
                                    </tr>
                                    <tr v-if="action.action_document">
                                        <td width="200">{{ uLang('app.action_document') }}:</td>
                                        <td>
                                            <b-badge pill variant="primary">
                                                <router-link :to="{name: 'admin.action-documents.view', params: {id: action.action_document_id}}">
                                                    {{ action.action_document.name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr v-if="action.selling_price_type">
                                        <td width="200">{{ uLang('app.selling_price') }}:</td>
                                        <td v-if="action.selling_price_type === '€'">€{{ action.selling_price_amount }}</td>
                                        <td v-else-if="action.selling_price_type === '%'">{{ action.selling_price_amount }}&#37;</td>
                                        <td v-else>{{ action.selling_price_amount }}</td>
                                    </tr>
                                    <tr v-if="action.do_not_create_sales_invoice">
                                        <td width="200">{{ uLang('app.do_not_create_sales_invoice') }}:</td>
                                        <td><b-badge pill variant="primary">{{ uLang('app.' + (action.do_not_create_sales_invoice ? 'yes' : 'no')) }}</b-badge></td>
                                    </tr>
                                    <tr v-if="action.selling_vat">
                                        <td width="200">{{ uLang('app.selling_vat') }}:</td>
                                        <td>{{ action.selling_vat ? action.selling_vat + '%' : '' }}</td>
                                    </tr>
                                    <tr v-if="action.purchase_price_type">
                                        <td width="200">{{ uLang('app.purchase_price') }}:</td>
                                        <td v-if="action.purchase_price_type === '€'">€{{ action.purchase_price_amount }}</td>
                                        <td v-else-if="action.purchase_price_type === '%'">{{ action.purchase_price_amount }}&#37;</td>
                                        <td v-else>{{ action.purchase_price_amount }}</td>
                                    </tr>
                                    <tr v-if="action.purchase_vat">
                                        <td width="200">{{ uLang('app.purchase_vat') }}:</td>
                                        <td>{{ action.purchase_vat ? action.purchase_vat + '%' : '' }}</td>
                                    </tr>
                                    <tr v-if="action.invoice_description">
                                        <td width="200">{{ uLang('app.invoice_description') }}:</td>
                                        <td>{{ action.invoice_description  }}</td>
                                    </tr>
                                    <tr v-if="action.mail_alert">
                                        <td width="200">{{ uLang('app.mail_alert') }}:</td>
                                        <td><b-badge pill variant="primary">{{ uLang('app.' + (action.mail_alert ? 'yes' : 'no')) }}</b-badge></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'show',
        props: {
            projectId: {
                required: true,
            },
            trajectoryId: {
                required: true,
            },
            milestoneId: {
                required: true,
            },
            id: {
                required: true,
            },
        },

        data() {
            return {
                project: undefined,
                trajectory: undefined,
                milestone: undefined,
                action: undefined,
            }
        },

        created() {
            this.retrieveProject();
            this.retrieveTrajectory();
            this.retrieveMilestone();
            this.retrieveAction();
        },

        methods: {
            async retrieveProject() {
                const {data} = await window.axios.get(route('trajectory-projects.show', { trajectory_project: this.projectId }));
                this.project = data;
            },

            async retrieveTrajectory() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId }));
                this.trajectory = data;
            },

            async retrieveMilestone() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.milestones.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId }));
                this.milestone = data;
            },

            async retrieveAction() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.milestones.actions.show_with_milestone_names', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId, action:  this.id }));
                this.action = data;
            },

            edit() {
                this.$router.push({ name: 'admin.trajectory_projects.trajectories.milestones.actions.edit', params: { projectId: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId, id: this.id } })
            },

            async duplicate() {
                let {data} = await window.axios.post(route('trajectory-projects.trajectories.milestones.actions.duplicate', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId, action:  this.id }));

                this.$router.push({ name: 'admin.trajectory_projects.trajectories.milestones.actions.edit', params: { projectId: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId, id: data.id }});
            },
        },
    }
</script>

<style lang="scss" scoped>
    .card-block {
        padding: 0 !important;
    }
</style>
